import { fromJS } from 'immutable';
import { migrateUserError } from './error';

import {
  validateLegacyUser,
  migrateAdditionalAccount,
  resetUserValidation,
  setValidationError,
  migrateUser,
  registerInvite,
  legacyPasswordRecover,
  legacyPasswordReset,
  recoverUsername,
  setUserResetEmail,
  getIdmUser
} from './actions';

import { passwordRecover, passwordReset } from '../user/actions';

export const defaultState = fromJS({
  userValidation: null,
  validationError: '',
  newUser: null,
  idmMigrateUser: null,
  userResetEmail: null
});

export default function migrate(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case validateLegacyUser.event.success:
    case migrateAdditionalAccount.event.success:
      return newState.set('userValidation', action.payload);

    case migrateUser.event.success:
      return newState.set('newUser', action.payload);

    case registerInvite.event.success:
      return newState.set('newUser', action.payload);

    case resetUserValidation.type:
      return newState.set('userValidation', null);

    case setValidationError.type:
      return newState.set('validationError', action.payload);

    case setUserResetEmail.type:
      return newState.set('userResetEmail', action.payload);

    case getIdmUser.event.success:
      return newState.set('idmMigrateUser', action.payload);

    case legacyPasswordRecover.event.error:
    case legacyPasswordReset.event.error:
    case passwordRecover.event.error:
    case passwordReset.event.error:
    case recoverUsername.event.error:
    case validateLegacyUser.event.error:
    case migrateAdditionalAccount.event.error:
    case registerInvite.event.error:
    case migrateUser.event.error:
      return newState.set('validationError', migrateUserError(action));

    default:
      return newState;
  }
}

export const userValidation = state => state.migrate.get('userValidation');
export const isUserValidated = state => state.migrate.getIn(['userValidation', 'statusCode']) === 'A';
export const validationError = state => state.migrate.get('validationError');
export const newUser = state => state.migrate.get('newUser');
export const idmMigrateUser = state => state.migrate.get('idmMigrateUser');
export const userResetEmail = state => state.migrate.get('userResetEmail');
